import React, { lazy, Suspense } from 'react';

const MapSearch = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const MapSearchSuspense = () => (
  <Suspense fallback={renderLoader()}>
    <MapSearch />
  </Suspense>
);

export default MapSearchSuspense;
